// extracted by mini-css-extract-plugin
module.exports = {"innerDoc":"InnerDoc_innerDoc__2uMt7","innerDocContent":"InnerDoc_innerDocContent__VBd1_"};